export default __webpack_public_path__ + "static/media/ScholarCourseImage3.5b070d17.svg";